const host = process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === "stubs" ? "https://www.integration.project4.com" : "";

const esiSourceWrapper = route => `${host}${route}?includeCoreJS=false&includePolyfills=false&isJoyfullyBold=true`;

export const ESIInclude = "esi:include";

export default esiSourceWrapper;
